import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { CarrierItemFlowService } from "src/app/_api/services/carrier-item-flow.service";
import { SystemsService } from "src/app/_api/services/systems.services";
import { TimesService } from "src/app/_api/services/times.service";
import { LanguageService } from "src/app/shared/services/language.service";
import { Subscription } from "rxjs";
import { DateRangeEventService } from "src/app/shared/services/date-range-event.service";
import { DecimalToTimeFormatPipe } from "src/app/shared/pipes/decimal-to-time-format";
import { BarchartModel } from "src/app/shared/converters/barchart.model";
import { ChartHoursByTimetypeInPeriodConverter } from "src/app/shared/converters/chart-hours-by-timetype-in-period.converter";
import * as moment from "moment";

@Component({
  selector: "app-project-portal-approval-details",
  templateUrl: "./project-portal-approval-details.component.html",
  styleUrls: ["./project-portal-approval-details.component.css"],
})

export class ProjectPortalApprovalDetailsComponent
  implements OnInit, OnChanges
{
  @Input() selectedTimeRecord: any;
  @Input() weekOverview = [];
  @Input() transportWeekOverview = [];
  @Input() selectedWeekNo: number;
  @Input() portalType: string;
  @Output() isBusy = new EventEmitter<boolean>();
  @Input() projectReadWriteAll: boolean;
  @Input() overTimeCheckActive: boolean; 
  
  @Input() selectedDateInterval: any;
  @Input() dateRangeSelectedIndex: number;
  @Input() selectedProjectId: number;
    @Input() employees = [];

  searchRequest: any;
 
  carrierItemFlows: any = [];
  items: any = [];
  gridSections: any = [];
  fromDate: Date = new Date();
  toDate: Date = new Date();

  dateRangeEventSubscription: Subscription;
  dateInterval: any = { FromDate: moment(), ToDate: moment() };

  barchartModel: BarchartModel;
  chartTitle = this.languageService.LNG('Label.TimeTypes');

  constructor(
    public languageService: LanguageService,    
    
    private timesService: TimesService,
    private carrierItemFlowService: CarrierItemFlowService,
    private systemService: SystemsService,
    private dateRangeEventService: DateRangeEventService,
    private chartHoursByTimetypeInPeriodConverter: ChartHoursByTimetypeInPeriodConverter,) {

    this.dateRangeEventSubscription = this.dateRangeEventService.onDateRangeChanged().subscribe((dateInterval) => {
      this.dateInterval = dateInterval;
    });
  }

  ngOnInit(): void {
    this.showGridSections();
  }

  ngOnChanges(changes: SimpleChanges) {
    const hasChangedSelectedTimeRecord = changes.selectedTimeRecord !== undefined && changes.selectedTimeRecord.previousValue !== changes.selectedTimeRecord.currentValue;
    const hasChangedSelectedDateInterval = changes.selectedDateInterval !== undefined && changes.selectedDateInterval.previousValue !== changes.selectedDateInterval.currentValue;

    if (hasChangedSelectedTimeRecord === false && hasChangedSelectedDateInterval === false) { return; }

    this.load();
  }

  private async showGridSections(): Promise<any> {
    this.gridSections = await this.systemService.showPortalGridSections().toPromise();
  }

  private async load() {
    if (!this.selectedTimeRecord) {
      this.transportWeekOverview = [];
      this.barchartModel = undefined; 
      this.chartTitle = this.languageService.LNG('Label.TimeTypes');
      this.carrierItemFlows = [];
      return;
    }

    const asyncOperations: Promise<any>[] = [
      this.loadChartTimes(),
      this.loadCarrierItemFlows(),
      this.loadItems()
    ];

    this.isBusy.emit(true);
    await Promise.all(asyncOperations);
    this.updateChartTitle();
    this.isBusy.emit(false);
  }  

  private async loadChartTimes() {
    const chartTimes = await this.timesService.getProjectPortalChartTimesWithinPeriod(this.selectedTimeRecord.CarrierProjectId, this.selectedTimeRecord.EmployeeId, this.selectedDateInterval.FromDate, this.selectedDateInterval.ToDate, this.selectedTimeRecord.CategoryId, this.selectedTimeRecord.TimeTypeId).toPromise();
    this.barchartModel = this.chartHoursByTimetypeInPeriodConverter.getConvertedChartModel(chartTimes, this.selectedDateInterval.FromDate, this.selectedDateInterval.ToDate, this.dateRangeSelectedIndex);
  }

  private updateChartTitle() {
    let total = 0;

    if (!this.barchartModel) return;

    for (const dataItem of this.barchartModel.dataSource) {
      for (const series of this.barchartModel.series) {
        total += dataItem[series.valueField];
      }
    }

    const totalValue = total > 0 ? new DecimalToTimeFormatPipe().transform(total): 0;

    this.chartTitle = total > 0
      ? `${this.languageService.LNG('Label.TimeTypes')} (${this.languageService.LNG('Label.Sum')}: ${totalValue})`
      : this.languageService.LNG('Label.TimeTypes');
  }

  private async loadCarrierItemFlows(): Promise<any> {
    if(this.selectedTimeRecord.CategoryId === 8 || this.selectedTimeRecord.CategoryId === 7) {
      this.carrierItemFlows = await this.carrierItemFlowService
        .getByTime(this.selectedTimeRecord.TimeId)
        .toPromise();
    }
    else {
      this.carrierItemFlows = await this.carrierItemFlowService
        .getByTimeEmployeeWithinPeriod(this.selectedTimeRecord.TimeId, this.selectedTimeRecord.EmployeeId, this.dateInterval.FromDate, this.dateInterval.ToDate)
        .toPromise();
    }
  }

  private async loadItems(): Promise<any> {
    this.items = await this.carrierItemFlowService.getArticles().toPromise();
  }

  customizeBarChartTooltip(arg: any) {
    const timeValue = arg.value > 0 ? new DecimalToTimeFormatPipe().transform(arg.value) : 0;
    const totalTimeValue = arg.total > 0 ? new DecimalToTimeFormatPipe().transform(arg.total) : 0; 
    return { text: arg.seriesName + ': ' + timeValue + '<br>' + 'Total: ' + totalTimeValue };
  }
}
